import React from 'react';
import Icon from '../atoms/Icon';

function TransferPortalProfileIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
       <g
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="currentColor"
          strokeWidth={2.0}
          strokeLinejoin="round"
        >
          <path d="M1.20834 15.7083C1.20834 23.7165 7.70021 30.2083 15.7083 30.2083C23.7165 30.2083 30.2083 23.7165 30.2083 15.7083C30.2083 7.7002 23.7165 1.20833 15.7083 1.20833C7.70021 1.20833 1.20834 7.7002 1.20834 15.7083Z"/>
          <path d="M21.75 15.7083L7.25 15.7083"/>
          <path d="M15.7086 8.82059L22.5961 15.7081L15.7086 22.5956"/>
        </g>
    </Icon>
  );
}
export default React.forwardRef(TransferPortalProfileIcon);
